import { render } from "./ThankYou.vue?vue&type=template&id=0fc44812&scoped=true&ts=true"
import script from "./ThankYou.vue?vue&type=script&lang=ts"
export * from "./ThankYou.vue?vue&type=script&lang=ts"

import "./ThankYou.vue?vue&type=style&index=0&id=0fc44812&scoped=true&lang=css"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc44812"]])

export default __exports__